import axiosInstance from "app/axiosInstance";

class ReportsService {
  static generateReport = async (data: any) => {
    return await axiosInstance.post(`/reports`, {
      ...data,
      shouldNotResolveAddresses: true
    });
  };

  static listXarReport = async (data: any) => {
    return await axiosInstance.post(`/reports/xar`, {
      ...data
    });
  };

  static generateXarReport = async (data: any) => {
    return await axiosInstance.post(`/reports/xar/generate`, {
      ...data
    });
  };

  static downloadXarReport = async (data: any) => {
    return await axiosInstance.post(
      `/reports/xar/download`,
      {
        ...data
      },
      {
        responseType: "arraybuffer"
      }
    );
  };

  static exportReport = async (data: any) => {
    return await axiosInstance.post(`/reports/export`, {
      ...data
    });
  };
}

export default ReportsService;
